import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { permissions, setRouter } from 'src/helpers';
import model from './model';
import { MCButton, MCError, Spinner } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import { BASE_ICONS } from 'src/components/svg';

const SignInCode = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setRouter({
      location,
      navigate
    });
    model.checkCode(new URLSearchParams(location.search).get('code'), (error, data) => {
      if (data?.ok) {
        if (model.isLogged && data.session) model.emit('logout');
        let redirect = '/';
        let params = { isRedirect: true };
        if (data.action === 'invoice_detail') {
          redirect = permissions.PAGES.INVOICES_PAGE.path;
          params.invoiceId = data.invoiceId;
        }
        if (model.isLogged) navigate(redirect, { state: params });
        else {
          permissions.history = {
            url: redirect,
            params
          };
          model.emit('auth', data.session);
        }
      } else {
        setError(LANG_CONST.validation.link_invalid);
        setLoading(false);
        // setTimeout(() => {
        //   navigate('/');
        // }, 10000);
      }
    });
  }, [location, navigate]);

  return (
    <div className={'mc-page-main'}>
      <div className={'mc-container'}>
        {loading ? (
          <div className={'mc-m-auto'}>
            <Spinner />
          </div>
        ) : (
          <div className={'mc-container-content'}>
            <div className={'mc-m-auto mc-flex-20-col'}>
              <MCError error={error} mcTextProps={{ style: { textAlign: 'center' } }} />
              <MCButton
                iconname={BASE_ICONS.BACK_ARROW}
                label={LANG_CONST.buttons.back_to_app}
                primary
                transparent
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/');
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};


SignInCode.displayName = 'SignInCode';

export default SignInCode;
